// @flow
import styled from 'styled-components';
import { media } from '~/core/utils/style';
import { StyledButton } from '~/components/widgets/buttons/button/styles';

export const RemoveButton = styled(StyledButton)`
    ${media.mobile`
    margin: 0.75rem auto;
    display: block;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/remove-device/styles.js